<script>
import Base from "@/components/RequestDetails/RequestTickets.vue";

export default {
  name: "DefaultViewRequestTickets",
  extends: Base,
};
</script>

